<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    label?: string
    description?: string
    id: string
    isDisabled?: boolean
    isReversed?: boolean
    fontColorGradient?: string
    fontColor?: string
  }>(),
  {
    label: '',
    description: '',
    isReversed: false,
    fontColorGradient: '900',
    fontColor: 'gray'
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const slot = defineSlots<{ label?: () => any }>()

const switchLabelTextColor = computed(() => {
  if (props.isDisabled) return 'text-foreground-disabled'
  return `text-${props.fontColor}-${props.fontColorGradient}`
})
</script>

<template>
  <div class="flex items-center justify-between" :class="isReversed && 'flex-row-reverse'">
    <span v-if="label || slot.label || description" class="flex grow flex-col">
      <label
        v-if="label || slot.label"
        :for="id"
        class="text-sm font-medium"
        :class="[isReversed ? 'ml-4' : 'mr-4', switchLabelTextColor, !isDisabled && 'cursor-pointer']"
      >
        {{ label }}
        <slot v-if="slot.label" name="label" />
      </label>
      <span v-if="description" class="text-sm text-muted-foreground">{{ description }}</span>
    </span>

    <Switch
      :id="id"
      :model-value="modelValue"
      :disabled="isDisabled"
      :class="!isDisabled && 'cursor-pointer'"
      @update:model-value="(v: boolean) => emit('update:modelValue', v)"
    />
  </div>
</template>
